"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFallbackImage = exports.StyledFallbackImage = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledFallbackImage = styled_1.default.img `
  display: block;
  height: auto;
  width: 100%;
`;
exports.ErrorFallbackImage = styled_1.default.img `
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_medium')};
`;
//# sourceMappingURL=styles.js.map